module.exports = __webpack_public_path__ + "22c1b697b05e970e05d9df7234bd2abe.jpg";